module.exports = __webpack_public_path__ + "static/img/bg25.2af8821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg25.jpg
// module id = 6LCC
// module chunks = 1